import { render, staticRenderFns } from "./Teknis.vue?vue&type=template&id=4cca7485&"
import script from "./Teknis.vue?vue&type=script&lang=js&"
export * from "./Teknis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports